import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './Accordion.module.scss';
import clsx from 'clsx';
import React, { useLayoutEffect, useEffect, useRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';

export const AccordionPanel = ({
  id = '0',
  children,
  isNoDelay = false,
  isSectionOpen = false,
  customClasses = null,
  dynamicHeight = false,
  // Sometimes accordion content is dynamic and could be transformed by child
  // in this case parent will not be rerendered and will not recalculate child
  // height by ref
  staticMaxHeight = 0,
  isGlobalLoaderShow,
  triggerRoute,
  ...rest
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);
  const ref = useRef(null);
  const [contentMaxHeight, setContentMaxHeight] = useState(staticMaxHeight);
  const [hasRendered, setHasRendered] = useState(false);

  const { ...springProps } = useSpring({
    maxHeight: isSectionOpen
      ? !dynamicHeight
        ? `${contentMaxHeight}px`
        : '100%'
      : '0px',
    config: { duration: !hasRendered || isNoDelay ? 0 : 180 },
  });

  useEffect(() => {
    if (!isSectionOpen && ref?.current?.getBoundingClientRect()?.top < 0) {
      document
        .querySelector('#title_1')
        ?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isSectionOpen]);

  useEffect(() => {
    const timeout = setTimeout(() => setHasRendered(true), 1);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  useLayoutEffect(() => {
    if (staticMaxHeight) return;

    const calcContentMaxHeight = () => {
      ref && ref.current && setContentMaxHeight(ref.current.scrollHeight);
    };
    calcContentMaxHeight();
    window.addEventListener('resize', () => calcContentMaxHeight());

    return () => window.removeEventListener('resize', calcContentMaxHeight());
  }, [ref, triggerRoute, isGlobalLoaderShow]);

  // eslint-disable-next-line no-unused-vars
  const { handleSectionToggleWithId, ...cleanRest } = rest;
  return (
    <animated.div
      style={{
        overflow: 'hidden',
        ...springProps,
      }}
      className={clsx(styles.panel, styles.rangePanel)}
      id={`section_${id}`}
      role="region"
      aria-labelledby={`title_${id}`}
      ref={ref}
    >
      <div
        className={clsx(styles.wrapper, styles.customWrapper)}
        {...cleanRest}
      >
        {children}
      </div>
    </animated.div>
  );
};
